import "./LivingRoom.css";

import * as React from "react";
import { TView } from "../App";

interface ILivingRoomProps {
    changeHandler: (view: TView) => void;
}

export default class LivingRoom extends React.Component<ILivingRoomProps> {

    public render() {
        return (
            <div className="LivingRoom">
                <div className="LivingRoom__title">
                    <span>WOHNZIMMER&shy;</span>KONZERTE
                </div>
                <p>
                    Zuhause klingt es manchmal am schönsten... Wir kommen zu Euch nach
                    Hause und machen Musik für Euch.
                    <br/><br/>
                    Die Idee kam einer Freundin, die ein Geburtstagsgeschenk für einen
                    Freund suchte: Ich verschenke Euch! Gerne, sagten wir, und seitdem
                    musizieren wir in den Wohnzimmern dieser Welt.
                    <br/><br/>
                    Wenn Ihr wollt, auch in Eurem. Schreibt uns gerne über
                    das <a href="" onClick={() => this.props.changeHandler("contact")}>Kontaktformular</a>.
                </p>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LivingRoom.tsx